<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">

                </v-col> 
                <v-col cols="12" xs="11" sm="11" md="4" lg="4" xl="4">
                    <alert-component :alert="alerts.choice"></alert-component>
                </v-col>
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">
                    
                </v-col>  
            </v-row>  


            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        dark
                        color="pink"
                        block
                        :to="{ 
                            name: 'admin.proposals.store', 
                        }"
                    >
                        Cadastrar uma nova proposta
                    </v-btn>
                </v-col> 
                <v-spacer />    
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        color="primary"
                        block
                        :to="{ 
                            name: 'admin.proposals.filter', 
                        }"
                    >
                        Pesquisar uma proposta
                    </v-btn>
                </v-col> 
                <v-spacer/> 
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Nova' | statusProposal"
                        block
                        :to="{ 
                            name: 'admin.proposals.search',
                            query: {
                                multiple_status: ['Nova']
                            } 
                        }"
                    >
                        propostas nova
                    </v-btn>
                </v-col> 
                <v-spacer/>   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Pendente' | statusProposal"
                        block
                        :to="{ 
                            name: 'admin.proposals.search',
                            query: {
                                multiple_status: ['Pendente']
                            } 
                        }"
                    >
                        propostas pendente
                    </v-btn>
                </v-col> 
                <v-spacer/>   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Em análise' | statusProposal"
                        block
                        :to="{ 
                            name: 'admin.proposals.search',
                            query: {
                                multiple_status: ['Em análise']
                            } 
                        }"
                    >
                        propostas em análise
                    </v-btn>
                </v-col> 
                <v-spacer/>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AlertComponent from '@/components/alert/AlertComponent.vue'

export default {
    name: 'ProposalIndex',

    components: {
        AlertComponent
    }, 

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },
    
    mounted() {
        window.scrollTo(0, 0);
    },

    data () {
        return {
            alerts: {
                choice: {
                    show: '',
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Escolha uma das opções abaixo.']
                },
            }

        }
    }
    
    //http://localhost:8080/proposals/search?multiple_status=Pendente
}
</script>